import { defineAction, object } from '~/prix'
import neighborhoodFetchAction from './geoNeighborhoodFetch.action.json' with { type: 'json' }
// import { z } from 'zod'
// import { multiPolygon, polygon } from '~/prix/types/presets/geo'

const neighborhoodFetchDefinition = defineAction({
  ...neighborhoodFetchAction,

  // input: z.object({
  //   municipalityId: z.number().nullish(),
  //   includeCommunities: z.boolean().nullish(),
  // }),
  // output: z.object({
  //   items: z.array(
  //     z.object({
  //       id: z.number().nullish(),
  //       name: z.string().nullish(),
  //       alternativeNames: z.string().nullish(),
  //       kind: z.string().nullish(),
  //       coverageArea: z.union([multiPolygon(), polygon()]).nullish(),
  //     }),
  //   ),
  // }),

  input: object<any>({}),
  output: object<any>({}),
})

export default neighborhoodFetchDefinition
